"use client";

import {useEffect, useState} from "react";
import {getLocalStorage, setLocalStorage} from "@/lib/utils/storage-helper";

export default function CookieBanner(){
    const [cookieConsent, setCookieConsent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        const storedCookieConsent = getLocalStorage("cookieConsent", null);
        //console.log("Je passe dans l'initialisation val de stored : ", storedCookieConsent);
        setCookieConsent(storedCookieConsent);
    },[setCookieConsent]);



    function applyCookieConsent(status){
        setLocalStorage("cookieConsent",status);
        //TODO action here
        setCookieConsent(status);
    }


    useEffect(()=>{
        const timer = setTimeout(()=>setLoading(false), 500);
        return () => clearTimeout(timer);
    }, [])

    if(loading) return <></>
    return (
        <div
            className={`
            
                ${cookieConsent !== null ? "hidden" : " flex flex-col fixed inset-x-0 bottom-0 z-50 justify-between gap-x-8 gap-y-4 bg-white p-6 ring-1 ring-gray-900/10 md:flex-row md:items-center lg:px-10 xs:block"}
            `}
        >
            <p className="max-w-4xl text-sm leading-6 text-gray-900">
                Ce site web utilise des cookies pour améliorer votre expérience de navigation, analyser le trafic du
                site et offrir une meilleure expérience aux utilisateurs.
            </p>
            <div className="flex gap-2">
                <div className="mr-16 flex flex-none items-center gap-x-5">
                    <button
                        onClick={() => applyCookieConsent(true)}
                        type="button"
                        className="rounded-md bg-primary px-3 py-2 text-sm font-semibold border-primary text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                    >
                        Accepter tout
                    </button>
                    <button
                        onClick={() => applyCookieConsent(false)}
                        type="button"
                        className="rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold border-primary text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
                    >
                        Rejeter tout
                    </button>
                </div>
            </div>

        </div>
    )
}